import React from "react";
import { FORM_CONTEXT_ACTIONS, formatFormContextMessage } from "../../../utils/recommendationFormContext";
import { EllipsisTooltipText } from "../../common/components/EllipsisTextWithTooltip";
import "../../../assets/css/form-context-banner.css";

const iconClassForAction = actionKey => {
    if (actionKey === FORM_CONTEXT_ACTIONS.CONVERTING) {
        return "fas fa-exchange-alt";
    }
    return "fas fa-info-circle";
};

const FormContextBanner = ({ banner }) => {
    const message = formatFormContextMessage(banner);
    if (!message) return null;

    const actionKey = banner?.actionKey || FORM_CONTEXT_ACTIONS.ADD;

    return (
        <li className="form-context-info-slot">
            <span className={`form-context-info form-context-info--${actionKey}`} aria-label={message}>
                <i className={`${iconClassForAction(actionKey)} form-context-info__icon`} aria-hidden="true" />
                <EllipsisTooltipText text={message} className="form-context-info__text" tooltipPlace="bottom" />
            </span>
        </li>
    );
};

export default FormContextBanner;
